import { Component, OnInit, TemplateRef } from '@angular/core';
import { ContractService } from '../service/contract.service'
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment';

import * as firebase from 'firebase';

@Component({
    selector: 'wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.css']
})

export class WizardComponent implements OnInit {

    public step = 0;
    public model = null;

    useremail : string = '';
    userpwd   : string = '';
    userlogged: boolean = false;

    // TODO
    contractIds = {
        0: [19, 23, 24, 25],
        1: [54],
        2: [20, 21, 22, 26, 23],
    };

    public intents = {
        0: [
            "{{B}} želi trećoj osobi ustupiti tražbinu prema {{A}}",
            "treća osoba želi preuzeti dug {{A}} prema {{B}}, čime treća osoba umjesto {{A}} postaje dužnik {{B}}",
            "treća osoba se obvezuje {{B}} da će ispuniti dug {{A}} prema {{B}}, ako to {{A}} ne učini",
            "treća osoba se obvezuje {{A}} da će ispuniti njegov dug prema {{B}}",
        ],
        2: [
            "{{B}} želi umjesto plaćanja {{C}}, ustupiti {{C}} potraživanje koje ima prema {{A}}, i time podmiriti svoj dug prema {{C}}",
            "{{B}} želi radi ispunjenja obveze prema {{C}}, ustupiti {{C}} potraživanje koje ima prema {{A}}, i time podmiriti svoj dug prema {{C}}, pri čemu obveza {{B}} prema {{C}} prestaje tek kada {{C}} naplati preuzetu tražbinu od {{A}}",
            "{{B}} želi radni osiguranja ispunjenja obveze prema {{C}}, ustupiti {{C}} potraživanje koje ima prema {{A}}, čime {{C}} dobiva osiguranje potraživanja za svoju tražbinu prema {{B}}",
            "{{A}} će platiti {{C}} umjesto {{B}}, a {{C}} će primiti takvo ispunjenje u svoje ime",
            "{{A}} će preuzeti dug {{B}} prema {{C}} i time će se novonastala obveza {{B}} prema {{A}} uslijed preuzimanja duga kompenzirati (prebiti) s postojećom obvezom {{A}} prema {{B}}, dok obveze {{B}} prema {{C}} više nema jer je ista preuzeta ugovorom o preuzimanju duga. Nakon navedenog odnosa ostati će samo obveza {{A}} prema {{C}}",
        ],
    }

    public isRelation(r: number) {
        return r === this.model.relation;
    }

    public selectRelation(r: number) {
        if (this.step !== 0) { return; }
        this.model.relation = r;
    }

    public isChoice(c: number) {
        return c === this.model.choice;
    }

    public showStep2() {
        return this.step >= 1 && this.model.relation !== 1;
    }

    public showStep3() {
        return this.step >= 2;
    }

    public canAdvance() {
        return this.model.sides[this.model.relation].A !== ""
            && this.model.sides[this.model.relation].B !== ""
            && (this.model.relation == 2 ? this.model.sides[this.model.relation].C !== "" : true);
    }

    public nextStep() {
        if (this.model.relation === 1) { this.step++; }
        this.step++;

    }

    public getSelectedContractId() {
        return this.contractIds[this.model.relation][this.model.choice];
    }

    public replace(choice: string) {
        return choice
            .replace(/{{A}}/g, this.model.sides[this.model.relation].A)
            .replace(/{{B}}/g, this.model.sides[this.model.relation].B)
            .replace(/{{C}}/g, this.model.sides[this.model.relation].C);
    }

    public reset() {
        this.step = 0;
        this.model = {
            relation: 0,
            choice: 0,
            sides: [
                {
                    A: "",
                    B: "",
                    C: null,
                },
                {
                    A: "",
                    B: "",
                    C: null,
                },
                {
                    A: "",
                    B: "",
                    C: "",
                }
            ]
        }
    }
    modalRef: BsModalRef;
    modalText: string = 'Link za prijavu putem kojega kao korisnik pristupate aplikaciji poslan je na upisanu e-mail adresu. Ukoliko ste ostali prijavljeni na drugom uređaju, link neće biti poslan na vašu e-mail adresu te prijava neće biti moguća dok se ne odjavite.';

    constructor(private contractService: ContractService, private modalService: BsModalService) { }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

    ngOnInit() {

        let config = {
            apiKey: environment.firebase_apiKey,
            authDomain: environment.firebase_authDomain,
            databaseURL: environment.firebase_databaseURL,
            projectId: environment.firebase_projectId,
            storageBucket: environment.firebase_storageBucket,
            messagingSenderId: environment.firebase_messagingSenderId
        };

        try {
            firebase.initializeApp(config);
        } catch (error) {}

        this.reset();

        firebase.auth().onAuthStateChanged( user => {
            if (!user) {
                this.userlogged = false;
                this.useremail = '';
            } else {
                this.userlogged = true;
                this.useremail = user.email;
            }
        });

    }
    
    login() {
        var actionCodeSettings = {
            // URL you want to redirect back to. The domain (www.example.com) for this
            // URL must be whitelisted in the Firebase Console.
            url: window.location.href,
            // This must be true.
            handleCodeInApp: true,
        };

        firebase.auth().sendSignInLinkToEmail( this.useremail, actionCodeSettings)
            .then(function () {
                // The link was successfully sent. Inform the user.
                // Save the email locally so you don't need to ask the user for it again
                // if they open the link on the same device.
                window.localStorage.setItem('emailForSignIn',  this.useremail);
            })
            .catch(function (error) {
                // Some error occurred, you can inspect the code: error.code
            });
    }
    
    logout() {
        
        console.log('signOut ...');
        firebase.auth().signOut();
    
    }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/wizard/wizard.component.ts